import { Button } from '@customerio/pluma-components/react';
import googleLogo from '@/assets/images/login-google-logo.svg';
import * as styles from '../index.css';

type GoogleAuthButtonProps = {
  type?: 'login' | 'signup';
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
};

/** "Sign in with Google" button. Copy + mark follow Google's branding guidelines. */
export function GoogleAuthButton({
  type = 'login',
  isDisabled,
  isLoading,
  onClick,
  'data-testid': dataTestId,
}: GoogleAuthButtonProps) {
  const label = type === 'login' ? 'Sign in with Google' : 'Continue with Google';

  return (
    <Button
      // Explicit button type so clicking it (to open the Google popup) never
      // implicitly submits a surrounding <Form>.
      type="button"
      variant="secondary"
      // Google brand styling (white surface, accent-subtle border, fit-content
      // for login / full-width for signup) — see the `google*Button` styles.
      className={type === 'login' ? styles.googleAuthButton : styles.googleSignupButton}
      iconSrc={googleLogo}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  );
}
